import axios from '../../api';

const BASE = process.env.REACT_APP_URL;

export const getBantuanLangkahByBantuan = (BantuanId) =>
  axios.get(`${BASE}/langkah/bantuan/${BantuanId}`);

export default {
  getBantuanLangkahByBantuan,
};
